;(function () {
  'use strict'

  angular
    .module('contrast.vendors')
    // eslint-disable-next-line no-undef
    .constant('Viva', Viva)
})()
